import React, { Component } from 'react'
import { Link } from 'react-router-dom'

const serviceModalContent = {
    "Sleep Consultation": {
        title: "Specialist Services",
        description: "Our experienced team of sleep specialists, pulmonologists, psychiatrists, endocrinologists, and other experts works together to understand your concerns. By reviewing your symptoms, medical history, and daily routines, we identify what is affecting your sleep and provide personalised care."
    },
    "Sleep Diagnostics": {
        title: "Diagnostic Services",
        description: "Our advanced sleep diagnostics include detailed sleep studies such as polysomnography, MSLT, MWT, and sleep tracking. These tools help us understand how your body behaves during sleep and allow us to pinpoint issues accurately without guesswork."
    },
    "Sleep Treatment": {
        title: "Treatment Services",
        description: "Once diagnosed, we provide a range of treatment options, including therapeutic interventions, cognitive behavioural therapy, prescription support, CPAP/BiPAP therapy, and personalised programs aimed at restoring healthy sleep patterns and improving quality of life."
    },
    "Sleep Health Hygiene": {
        title: "Health Hygiene Services",
        description: "Small habits can make a big difference. Through sleep hygiene guidance, sleep tracking, and regular monitoring of your sleep pattern, we help you build healthier routines that support consistent and restorative sleep."
    },
    "Lifestyle Mentors": {
        title: "Lifestyle Mentors",
        description: "Good sleep is connected to how you live each day. Our dietitians, fitness coaches, and lifestyle mentors guide you in improving food choices, movement, stress management, and daily routines so your overall lifestyle supports healthier sleep."
    }
};

export class FeaturesOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            selectedService: null
        };
    }

    openModal = (service) => {
        this.setState({
            showModal: true,
            selectedService: service
        });
    }

    closeModal = () => {
        this.setState({
            showModal: false,
            selectedService: null
        });
    }

    render() {
        let FeaturesData = this.props.FeaturesData;
        const { showModal, selectedService } = this.state;
        const modalContent = selectedService ? serviceModalContent[selectedService] : null;

        return (
            <section className="features-wrapper section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className='col-md-12 text-center'>
                            <h2>Our Services</h2>
                        </div>
                        {
                            FeaturesData.items.map(item => {
                                const content = (
                                    <div className="single-feature-box" key={item.id}>
                                        <div className="icon-box">
                                            <img src={require("../../assets/img/whatsinaname/ourservice/" + item.imgUrl)} alt="" />
                                        </div>
                                        {!item.link && <h3>{item.title}</h3>}
                                        {item.link && <h3>{item.text}</h3>}
                                    </div>
                                );
                                return (
                                    <div className="col-md-6 col-12 col-lg-6 col-xl-4" key={item.id}>
                                        {item.link ? (
                                            <Link to={item.link} style={{textDecoration: 'none', color: 'inherit'}}>{content}</Link>
                                        ) : (
                                            <div onClick={() => this.openModal(item.title)} style={{cursor: 'pointer'}}>
                                                {content}
                                            </div>
                                        )}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                {/* Service Modal */}
                {showModal && modalContent && (
                    <div className="service-modal-overlay" onClick={this.closeModal} style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}>
                        <div className="service-modal-content" onClick={(e) => e.stopPropagation()} style={{
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            padding: '40px',
                            maxWidth: '600px',
                            width: '90%',
                            maxHeight: '80vh',
                            overflow: 'auto',
                            position: 'relative',
                            boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
                        }}>
                            <button onClick={this.closeModal} style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: '#666'
                            }}>&times;</button>
                            <h2 style={{
                                color: '#1E9BCC',
                                marginBottom: '20px',
                                fontSize: '1.8rem'
                            }}>{modalContent.title}</h2>
                            <p style={{
                                color: '#555',
                                lineHeight: '1.8',
                                fontSize: '1rem',
                                marginBottom: '30px'
                            }}>{modalContent.description}</p>
                            <Link to="/contact" className="fill-btn" style={{
                                display: 'block',
                                padding: '8px 15px',
                                margin:'25px auto',
                                backgroundColor: '#1E9BCC',
                                color: '#fff',
                                textDecoration: 'none',
                                textAlign:'center',
                                borderRadius: '5px',
                                fontWeight: '600'
                            }}>Enquire Now</Link>
                        </div>
                    </div>
                )}
            </section>
        )
    }
}

export default FeaturesOne
